import { useEffect } from "react";
import { Eyebrow, PrimaryCTA } from "../components/bits";

const Block = ({ title, children }) => (
    <div className="border-t border-linen py-8 first:border-t-0">
        <h2 className="font-serif text-xl uppercase tracking-tight text-ink">{title}</h2>
        <div className="mt-3 max-w-3xl space-y-3 text-sm leading-relaxed text-mute">{children}</div>
    </div>
);

export const LegalLayout = ({ eyebrow, title, updated, children }) => {
    useEffect(() => window.scrollTo(0, 0), []);
    return (
        <main className="pt-28 lg:pt-32">
            <div className="mx-auto max-w-4xl px-5 pb-24 lg:px-8">
                <Eyebrow>{eyebrow}</Eyebrow>
                <h1 className="mt-4 font-serif text-4xl uppercase leading-[1.08] tracking-tight text-ink sm:text-5xl">
                    {title}
                </h1>
                <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.24em] text-gold">
                    Last updated · {updated}
                </p>
                <div className="mt-10">{children}</div>
                <div className="mt-12 rounded-2xl border border-linen bg-ivory p-6 sm:p-8">
                    <p className="font-serif text-lg uppercase tracking-tight text-ink">
                        Questions about this document?
                    </p>
                    <p className="mt-2 text-sm text-mute">
                        Book a call and we’ll walk you through how we handle data, consent and outreach rules.
                    </p>
                    <div className="mt-5">
                        <PrimaryCTA testId={`${eyebrow.toLowerCase().replace(/\s+/g, "-")}-book-btn`}>
                            Book a Reactivation Call
                        </PrimaryCTA>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default function PrivacyPage() {
    return (
        <LegalLayout eyebrow="Legal" title="Privacy Policy" updated="July 2026">
            <Block title="Overview">
                <p>
                    Summercrest AI (“Summercrest”, “we”, “us”) provides client reactivation and rebooking systems
                    for cosmetic and aesthetic clinics. This policy explains how we handle personal information
                    when you visit our website or work with us.
                </p>
            </Block>
            <Block title="Information we collect">
                <p>
                    When you book a discovery call, our scheduling provider (Calendly) collects your name, email
                    address and any details you choose to share. Our website itself does not require an account
                    and does not collect clinic client data from visitors.
                </p>
            </Block>
            <Block title="Clinic client data">
                <p>
                    When we build a reactivation system for a clinic, the clinic remains the controller of its
                    client database. Outreach rules, consent requirements and opt-out handling are agreed during
                    onboarding before any message is sent, and are designed around the privacy and consent
                    requirements applicable to the clinic’s region.
                </p>
            </Block>
            <Block title="How we use information">
                <p>
                    We use contact details to run scheduled calls, deliver our services and communicate about
                    engagements. We do not sell personal information.
                </p>
            </Block>
            <Block title="Third-party services">
                <p>
                    We use a small number of providers to operate this website and our booking flow, including
                    Calendly for scheduling. Their own privacy policies apply to the data they process.
                </p>
            </Block>
            <Block title="Your choices">
                <p>
                    You can request access, correction or deletion of your personal information at any time by
                    contacting us through a discovery call. Marketing messages sent through client reactivation
                    systems always include a way to opt out.
                </p>
            </Block>
        </LegalLayout>
    );
}
